import React from 'react';
import { Tag } from 'syngenta-digital-cropwise-react-ui-kit';

type IntegrationTagProps = {
  color: string;
  children: React.ReactNode;
};

const IntegrationTag = ({ color, children }: IntegrationTagProps) => (
  <Tag
    color={color}
    style={{
      display: 'inline-flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: 20,
      margin: 0,
      padding: '0 4px',
      border: 0,
      borderRadius: 4,
      color: '#fff',
      fontSize: 12,
      fontWeight: 600,
      lineHeight: '20px',
      textTransform: 'none',
      letterSpacing: 'normal',
      verticalAlign: 'baseline',
      cursor: 'default'
    }}
  >
    {children}
  </Tag>
);

export default IntegrationTag;
